import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-line bg-white/95 shadow-sm backdrop-blur" data-id="element-240" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-white sm:text-xs md:text-sm" data-id="element-241" data-mp="1y30urred79g5">
        🇦🇷 EL SISTEMA COMPLETO PARA CORREDORES EN ARGENTINA
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-slate-500 md:flex" data-id="element-242" data-mp="2qr6fie5f4yfz">
        <span className="flex items-center gap-1.5" data-id="element-243" data-mp="2lvr21nbbp4k3">
          <ZapIcon className="h-3.5 w-3.5 text-accent" data-id="element-244" data-mp="2h1mv34224wj0" /> Acceso en 5 minutos
        </span>
        <span className="text-accent/40" data-id="element-245" data-mp="2c4d77subgsxa">·</span>
        <span className="flex items-center gap-1.5" data-id="element-246" data-mp="2c1h9o5mds69d">
          <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-247" data-mp="39k0uh831kqk7" /> Pago seguro
        </span>
        <span className="text-accent/40" data-id="element-248" data-mp="34rqwr5voqm7d">·</span>
        <span className="flex items-center gap-1.5" data-id="element-249" data-mp="34qxzcvim991w">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-250" data-mp="24zfc5aebm0z" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}